// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5b825921","769":"e85c53b2"}[chunkId] + ".chunk.js";
};